var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 2.24997C16.5318 2.75658 15.7366 3.14406 14.895 3.39747C14.4433 2.87811 13.843 2.50999 13.1753 2.34292C12.5076 2.17584 11.8046 2.21787 11.1616 2.46331C10.5185 2.70876 9.96633 3.14577 9.57974 3.71526C9.19314 4.28475 8.99077 4.95923 9 5.64747V6.39747C7.68198 6.43165 6.37596 6.13933 5.19826 5.54656C4.02056 4.95378 3.00774 4.07895 2.25 2.99997C2.25 2.99997 -0.75 9.74997 6 12.75C4.4554 13.7984 2.61537 14.3242 0.75 14.25C7.5 18 15.75 14.25 15.75 5.62497C15.7493 5.41606 15.7292 5.20767 15.69 5.00247C16.4555 4.24759 16.9956 3.29451 17.25 2.24997V2.24997Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f9eb56c57171133aaa12e30b93c265b8.svg";
export { ForwardRef as ReactComponent };